export const isNetworkError = (error: Error | { message: string }): boolean => {
  const msg = error.message.toLowerCase();
  return (
    msg.includes("fetch") ||
    msg.includes("network") ||
    msg.includes("failed to fetch") ||
    msg.includes("err_internet") ||
    msg.includes("timeout") ||
    msg.includes("aborted")
  );
};
